import type { ServiceArea } from "@/api.types.v2";
import { CreateServiceAreaForm } from "./create-service-area-form";
import {
  useUpdateServiceArea,
  type CreateServiceAreaFormData,
} from "@/api/service-areas";

interface EditServiceAreaFormProps {
  serviceArea: ServiceArea;
  onClose: () => void;
}

export function EditServiceAreaForm({
  serviceArea,
  onClose,
}: EditServiceAreaFormProps) {
  const updateServiceAreaMutation = useUpdateServiceArea({
    onSuccess: () => {
      onClose();
    },
  });

  return (
    <CreateServiceAreaForm
      mode="edit"
      defaultValues={{
        code: serviceArea.code,
        name: serviceArea.name,
        isActive: serviceArea.isActive,
        boundary: serviceArea.boundary as CreateServiceAreaFormData["boundary"],
        postcodes: serviceArea.postcodes,
        maxDailyOrders: serviceArea.maxDailyOrders ?? undefined,
        maxVehicles: serviceArea.maxVehicles ?? undefined,
        metadata: serviceArea.metadata ?? undefined,
      }}
      onSubmit={(values) =>
        updateServiceAreaMutation.mutate({
          serviceAreaId: serviceArea.id,
          data: values,
        })
      }
      onCancel={onClose}
    />
  );
}
